import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCirclePlaceholderOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCirclePlaceholderOff"><Path d="M22 12C22 13.669 21.5911 15.2425 20.8681 16.6259L7.37415 3.13195C8.75746 2.40888 10.331 2 12 2C17.5229 2 22 6.47715 22 12Z" fill="currentColor"/><Path d="M20.2928 21.7071L18.3285 19.7428C16.6052 21.1527 14.4008 21.9997 12 21.9997C6.47715 21.9997 2 17.5226 2 11.9997C2 9.59892 2.84702 7.39454 4.25694 5.6712L2.29285 3.70711L3.70706 2.29289L21.7071 20.2929L20.2928 21.7071Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCirclePlaceholderOff;
